import storage from "/src/utils/storage";

const storageLocal = storage('local');
const storageSession = storage('session');

const persistedUser = storageLocal.get('user') ?? storageSession.get('user') ?? {};
const persistedToken = storageLocal.get('token');
const persistedRefreshToken = storageLocal.get('refresh_token');

const initialAuthState = {
    user : persistedUser || {},
    error : undefined,
    token : persistedToken,
    refresh_token : persistedRefreshToken,
    fetching : false
}

export default initialAuthState;